import { TrackItem } from '../remotion-tracks';
import { AssetDisplay } from '../remotion-assets/remotion-assets';
import React, { FunctionComponent } from 'react';
import { SubtitleSeries } from '../remotion-subtitles/remotion-subtitles';
import {
  AudioTrack,
  CaptionSettings,
  DEFAULT_CAPTION_SETTINGS,
} from '../remotion-types';
import { AudioTrackPlayer } from '../remotion-audio/remotion-audio';
import { AbsoluteFill } from 'remotion';

interface Props {
  item: TrackItem;
  isRtl: boolean;
  absoluteFrame: number;
  index?: number;
}

const RemotionVoiceover: FunctionComponent<Props> = ({
  item,
  index = 0,
  isRtl,
  absoluteFrame,
}) => {
  const audioTrack = item.data as AudioTrack;

  const getSubtitles = () => {
    if (!audioTrack.subtitles) {
      return null;
    }
    if (!audioTrack.subtitlesConfig) {
      return null;
    }

    const isEnabled =
      audioTrack.subtitlesConfig.display && audioTrack.subtitles.length > 0;

    if (!isEnabled) {
      return false;
    }

    const captionSettings = {
      ...DEFAULT_CAPTION_SETTINGS,
      ...audioTrack.subtitlesConfig,
    };

    return (
      <SubtitleSeries
        isRtl={isRtl}
        absoluteFrame={absoluteFrame}
        subtitles={audioTrack.subtitles}
        settings={captionSettings as CaptionSettings}
      />
    );
  };

  return (
    <AbsoluteFill style={{ zIndex: 2 }}>
      <AudioTrackPlayer track={audioTrack} />
      {getSubtitles()}
    </AbsoluteFill>
  );
};

export default RemotionVoiceover;
